import { ReactNode } from 'react'

interface PageHeaderProps {
  title: string
  actions?: ReactNode
}

export function PageHeader({ title, actions }: PageHeaderProps) {
  return (
    <div className="flex flex-col gap-3 border-b border-border/70 pb-4 sm:flex-row sm:items-center sm:justify-between">
      <h1 className="text-xl font-semibold tracking-tight text-foreground">
        {title}
      </h1>
      {actions && <div className="flex shrink-0 flex-wrap gap-2 max-sm:[&_button]:h-10">{actions}</div>}
    </div>
  )
}
